module.exports = __webpack_public_path__ + "static/img/l7805cv-1.fb8f516.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/l7805cv-1.svg
// module id = e6KH
// module chunks = 0